import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/gameEventTabs.css';
import GameEventTab from '../components/gameEventTab.js';
import device from "current-device";
import {NEXT_EVENT_DISPLAY_MODE} from "../../../constants/bmsLogic";
import {CURRENT_NEXT, PRE, RES, VID} from "../../../constants/identifiers";
import {getText} from '../../../helpers/localization';
import {MATCHDAY_MODULE_TYPE} from "../../sports-book/modules/matchday/constants/identifiers";
import {selectEvent, setselectedMatchdaySubEventIndex, setEventTabClickStatus} from '../../../actions/eventsActions';
import {CUSTOMIZATION_ENABLED} from "../../../constants/bmsLogic";
import { isTextBasedGame } from '../modules/matchday/helpers/matchdayHelper.js';

const mapStateToProps = (state, ownProps) => {
    return {
        games: state.vpp.games,
        selectedGameIndex: state.vpp.selectedGameIndex,
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        isDesktopMode: state.vpp.isDesktopMode,
        matchdayUpdated: state.vpp.matchdayUpdated,
        systemLanguage: state.vpp.systemLanguage,
        isEventTabClicked:state.vpp.isEventTabClicked,
        selectedEventId:state.vpp.selectedEventId
    };
};

class GameEventTabs extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            isDesktopMode: storeData.vpp.isDesktopMode,
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            matchdayUpdated: storeData.vpp.matchdayUpdated,
            systemLanguage: storeData.vpp.systemLanguage,
            isEventTabClicked:storeData.vpp.isEventTabClicked,
            selectedEventId:storeData.vpp.selectedEventId

        };

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState(
                {
                    selectedGameIndex: storeData.vpp.selectedGameIndex,
                    games: storeData.vpp.games,
                    selectedEventIndex: storeData.vpp.selectedEventIndex,
                    events: storeData.vpp.events,
                    isDesktopMode: storeData.vpp.isDesktopMode,
                    matchdayUpdated: storeData.vpp.matchdayUpdated,
                    systemLanguage: storeData.vpp.systemLanguage,
                    isEventTabClicked:storeData.vpp.isEventTabClicked,
                    selectedEventId:storeData.vpp.selectedEventId
                }
            );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        CUSTOMIZATION_ENABLED && this.switchToDefaultDisplay(prevProps);
    }

    switchToDefaultDisplay(prevProps){
        this.resetGameTabClickEvent(prevProps);
        this.selectSecondEventTab(prevProps);
    }

    resetGameTabClickEvent(prevProps) {
        let selectedEventId = this.props.store.getState().vpp.selectedEventId;
        let prevSelectedEventId = prevProps.selectedEventId;
        let events = this.props.store.getState().vpp.events;
        let containInEventList = events && prevSelectedEventId ? events.some(event=>event.eventId === prevSelectedEventId) : false;
        if(selectedEventId !== prevSelectedEventId && !containInEventList){
            this.props.store.dispatch(setEventTabClickStatus(false));
        }
    }

    selectSecondEventTab(prevProps) {
        let events = this.props.store.getState().vpp.events;
        let prevEvents = prevProps.events;
        if(prevEvents && events && prevEvents !== events && !this.props.store.getState().vpp.isEventTabClicked){
            this.props.store.dispatch(selectEvent(1));
            this.props.store.dispatch(setselectedMatchdaySubEventIndex(0, this.props.store));
            this.props.store.dispatch(setEventTabClickStatus(false));
        }
    }

    render() {
        let isMobile = device.mobile() || !this.state.isDesktopMode;
        let store = this.props.store;
        let storeData = store.getState();
        let selectedGame = this.state.games[this.props.store.getState().vpp.selectedGameIndex];
        let channel = this.state.games[this.state.selectedGameIndex].channel;
        // Added NEXT_EVENT_DISPLAY_MODE for sisal integration
        let size = NEXT_EVENT_DISPLAY_MODE === CURRENT_NEXT
            ? 2
            : selectedGame.type === MATCHDAY_MODULE_TYPE ? (isTextBasedGame(channel) ? 5 : 3)
                : (!isMobile
                    ? 8
                    : 5);

        let gameEventTabsUI;
        let loadingUI;
        if (this.props.hasSelectedGameFutureEvents) {
            if (this.state.events && this.state.events.length && this.state.games && this.state.games.length
                && this.state.games[this.state.selectedGameIndex].channel === this.state.events[this.state.selectedEventIndex].channel
                && (process.env.NODE_ENV !== 'development'
                    ? (selectedGame.type === MATCHDAY_MODULE_TYPE
                        ? (this.props.store.getState().vpp.selectedEventIndex !== 0
                            ? this.state.matchdayUpdated !== false
                            : (selectedGame.controllerState !== undefined && selectedGame.controllerState[1] === PRE)
                                ? this.state.matchdayUpdated !== false
                                : true)
                        : true)
                    : true)) {

                let tabOneText = '';
                let tabTwoText = '';

                if (NEXT_EVENT_DISPLAY_MODE === CURRENT_NEXT) {
                    if (this.state.selectedGameIndex !== undefined && this.state.games[this.state.selectedGameIndex] !== undefined) {
                        let controllerState = this.state.games[this.state.selectedGameIndex].controllerState;

                        if (controllerState === VID || controllerState === RES || (controllerState !== undefined && controllerState[1] !== undefined && (controllerState[1] === VID || controllerState[1] === RES))) {
                            tabOneText = getText('PLAYING', this.props.store) + ' - ';
                            tabTwoText = getText('NEXT', this.props.store) + ' - ';
                        } else {
                            tabOneText = getText('NEXT', this.props.store) + ' - ';
                            tabTwoText = getText('FUTURE', this.props.store) + ' - ';
                        }
                    }
                }

                gameEventTabsUI = this.state.events.slice(0, size).map(
                    (event, index) => {
                        return (event !== undefined) ?
                            <GameEventTab
                                eventindex={index}
                                key={index}
                                store={this.props.store}
                                isSelected={index === this.state.selectedEventIndex}
                                timerText={index === 0 ? tabOneText : tabTwoText}
                                eventDate={event === undefined ? '' : Array.isArray(event) ? event[0].eventTimeDate : event.eventTimeDate}
                                matchdayIndex={!Array.isArray(event) ? '' : event[0].leagueDay}/>
                            : null;
                    });
                gameEventTabsUI = (<div className={style.gameEventTabs}>{gameEventTabsUI}</div>);
            } else {
                // loadingUI = (<div className={style.loadingOverlay}/>)
                loadingUI = (
                    <div className={style.loading}><span>&bull;</span><span>&bull;</span><span>&bull;</span></div>);
            }
        }

        let matchdaySpecialStyle = '';
        if (selectedGame.type === MATCHDAY_MODULE_TYPE && !isTextBasedGame(selectedGame.channel)) {
            matchdaySpecialStyle =
                (this.props.store.getState().vpp.selectedEventIndex !== 0)
                || (this.props.store.getState().vpp.selectedEventIndex === 0
                    && selectedGame.controllerState
                    && selectedGame.controllerState[1]
                    && (selectedGame.controllerState[1] === PRE))
                    ? style.matchdayEventTabContainer : '';
        }

        return (
            <div className={`${style.gameEventTabsContainer} ${matchdaySpecialStyle} ${isMobile
                ? style.mobile
                : ''}`}>
                {gameEventTabsUI}
                {/* <div id={'results'} className={style.resultContainer}>{getText('Results', this.props.store)}</div> */}
                {loadingUI}
            </div>
        );
    }
}

export default connect(mapStateToProps)(GameEventTabs);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/containers/gameEventTabs.js